import apiService from '../Api'
import { IExperimentalClassFormPayload, IExperimentalClassOptionRaw, IExperimentalClassRowRaw } from './types'

interface IListParams {
  start: number
  length: number
  search: string
  date: string
  consultantId: string
}

interface IListResponse {
  recordsTotal: number
  recordsFiltered: number
  data: IExperimentalClassRowRaw[]
}

type IMarkAttendedResponse = Pick<IExperimentalClassRowRaw, 'attended' | 'attended_at' | 'attended_by_name'>

export class ExperimentalClassService {
  async list(params: IListParams): Promise<IListResponse> {
    const queryParams = new URLSearchParams()
    queryParams.append('start', params.start.toString())
    queryParams.append('length', params.length.toString())
    queryParams.append('search', params.search)
    queryParams.append('date', params.date)
    queryParams.append('consultant_id', params.consultantId)

    return apiService.get('/experimental-classes', { params: queryParams }).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async create(payload: IExperimentalClassFormPayload): Promise<any> {
    return apiService.post('/experimental-classes', payload)
  }

  async getConsultants(): Promise<IExperimentalClassOptionRaw[]> {
    return apiService.get('/experimental-classes/consultants').then((response) => response.data)
  }

  async getCourses(): Promise<IExperimentalClassOptionRaw[]> {
    return apiService.get('/experimental-classes/courses').then((response) => response.data)
  }

  async getTeachers(): Promise<IExperimentalClassOptionRaw[]> {
    return apiService.get('/experimental-classes/teachers').then((response) => response.data)
  }

  async markAttended(studentId: number, attended: boolean): Promise<IMarkAttendedResponse> {
    return apiService
      .patch(`/experimental-classes/students/${studentId}/attended`, { attended })
      .then((response) => response.data)
  }
}
